import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import Pagination from '../Common/Pagination';

const AdminTextMessages = () => {
  const [textMessages, setTextMessages] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [search, setSearch] = useState('');
  const token = localStorage.getItem('adminToken');
  const navigate = useNavigate();

  useEffect(() => {
    fetchTextMessages();
  }, [currentPage, search]);

  const fetchTextMessages = async () => {
    setLoading(true);
    try {
      const response = await axios.get('/api/admin/text-messages', {
        params: { page: currentPage, search },
        headers: { Authorization: `Bearer ${token}` },
      });
      setTextMessages(response.data.textMessages);
      setTotalPages(response.data.totalPages);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching text messages:', error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`/api/admin/text-messages/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchTextMessages();
    } catch (error) {
      console.error('Error deleting text message:', error);
    }
  };

  const handleEdit = (id) => {
    navigate(`/admin/textmessages/edit/${id}`);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };

  return (
    <div className='container mx-auto px-4 py-8'>
      <h1 className='text-2xl font-bold mb-6'>Text Messages</h1>
      <input
        type='text'
        placeholder='Search text messages...'
        value={search}
        onChange={handleSearch}
        className='mb-4 p-2 border rounded w-full'
      />
      <table className='min-w-full bg-white shadow-md rounded-lg overflow-hidden'>
        <thead>
          <tr>
            <th className='py-2 px-4 border-b'>Content</th>
            <th className='py-2 px-4 border-b'>Scheduled Date</th>
            <th className='py-2 px-4 border-b'>Status</th>
            <th className='py-2 px-4 border-b'>Actions</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan='4' className='text-center py-6'>
                Loading...
              </td>
            </tr>
          ) : (
            textMessages.map((message) => (
              <tr key={message._id}>
                <td className='py-2 px-4 border-b'>{message.content}</td>
                <td className='py-2 px-4 border-b'>
                  {new Date(message.scheduledDate).toLocaleString()}
                </td>
                <td className='py-2 px-4 border-b'>{message.status}</td>
                <td className='py-2 px-4 border-b'>
                  <button
                    onClick={() => handleEdit(message._id)}
                    className='text-blue-500 mr-2'
                  >
                    Edit
                  </button>
                  <button
                    onClick={() => handleDelete(message._id)}
                    className='text-red-500'
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
      />
    </div>
  );
};

export default AdminTextMessages;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa';
// import Pagination from '../Common/Pagination';

// const AdminTextMessages = () => {
//   const [textMessages, setTextMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [page, setPage] = useState(1);
//   const [pages, setPages] = useState(1);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchTextMessages = async () => {
//       try {
//         const response = await axios.get(
//           `/api/admin/text-messages?pageNumber=${page}`,
//           {
//             headers: { Authorization: `Bearer ${token}` },
//           }
//         );
//         setTextMessages(response.data.textMessages);
//         setPages(response.data.pages);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching text messages:', error);
//         setLoading(false);
//       }
//     };

//     fetchTextMessages();
//   }, [page, token]);

//   const deleteTextMessage = async (id) => {
//     if (window.confirm('Are you sure you want to delete this text message?')) {
//       try {
//         await axios.delete(`/api/admin/text-messages/${id}`, {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setTextMessages(
//           textMessages.filter((textMessage) => textMessage._id !== id)
//         );
//       } catch (error) {
//         console.error('Error deleting text message:', error);
//       }
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div>
//       <h1 className='text-3xl font-bold mb-8'>Manage Text Messages</h1>
//       <Link
//         to='/admin/text-messages/create'
//         className='inline-block bg-blue-500 text-white py-2 px-4 rounded mb-8'
//       >
//         <FaPlus className='mr-2 inline' /> Add Text Message
//       </Link>
//       <table className='w-full text-left'>
//         <thead>
//           <tr>
//             <th className='p-4 border-b'>Content</th>
//             <th className='p-4 border-b'>Scheduled Date</th>
//             <th className='p-4 border-b'>Status</th>
//             <th className='p-4 border-b'>Actions</th>
//           </tr>
//         </thead>
//         <tbody>
//           {textMessages.map((textMessage) => (
//             <tr key={textMessage._id}>
//               <td className='p-4 border-b'>{textMessage.content}</td>
//               <td className='p-4 border-b'>
//                 {new Date(textMessage.scheduledDate).toLocaleString()}
//               </td>
//               <td className='p-4 border-b capitalize'>{textMessage.status}</td>
//               <td className='p-4 border-b flex'>
//                 <Link
//                   to={`/admin/text-messages/${textMessage._id}/edit`}
//                   className='mr-4 text-blue-500'
//                 >
//                   <FaEdit />
//                 </Link>
//                 <button
//                   onClick={() => deleteTextMessage(textMessage._id)}
//                   className='text-red-500'
//                 >
//                   <FaTrash />
//                 </button>
//               </td>
//             </tr>
//           ))}
//         </tbody>
//       </table>
//       <Pagination
//         page={page}
//         pages={pages}
//         onChangePage={(newPage) => setPage(newPage)}
//       />
//     </div>
//   );
// };

// export default AdminTextMessages;

// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Link } from 'react-router-dom';
// import { FaTrash, FaEdit, FaEnvelopeOpenText } from 'react-icons/fa';
// import ConfirmDialog from '../Common/ConfirmDialog';

// const AdminTextMessages = () => {
//   const [messages, setMessages] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);
//   const [isDialogOpen, setIsDialogOpen] = useState(false);
//   const [selectedMessageId, setSelectedMessageId] = useState(null);
//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchMessages = async () => {
//       try {
//         const response = await axios.get('/api/admin/textMessages', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setMessages(response.data);
//         setLoading(false);
//       } catch (err) {
//         setError(err.message);
//         setLoading(false);
//       }
//     };

//     fetchMessages();
//   }, [token]);

//   const handleDelete = async () => {
//     try {
//       await axios.delete(`/api/admin/textMessages/${selectedMessageId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setMessages(messages.filter((msg) => msg._id !== selectedMessageId));
//       setIsDialogOpen(false);
//     } catch (err) {
//       setError(err.message);
//     }
//   };

//   if (loading) return <div>Loading...</div>;
//   if (error) return <div className="text-red-500">{error}</div>;

//   return (
//     <div className="container mx-auto px-4 py-8">
//       <h1 className="text-3xl font-bold mb-6">Text Messages</h1>
//       <div className="mb-4">
//         <Link
//           to="/admin/textMessages/create"
//           className="bg-green-500 text-white py-2 px-4 rounded hover:bg-green-700 transition duration-200 inline-flex items-center"
//         >
//           <FaEnvelopeOpenText className="mr-2" /> Create Text Message
//         </Link>
//       </div>
//       <div className="bg-white shadow-md rounded-lg overflow-hidden">
//         <table className="min-w-full bg-white">
//           <thead>
//             <tr>
//               <th className="py-2 px-4 border-b border-gray-200">Content</th>
//               <th className="py-2 px-4 border-b border-gray-200">Status</th>
//               <th className="py-2 px-4 border-b border-gray-200">Scheduled Date</th>
//               <th className="py-2 px-4 border-b border-gray-200">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {messages.map((msg) => (
//               <tr key={msg._id}>
//                 <td className="py-2 px-4 border-b border-gray-200">{msg.content}</td>
//                 <td className="py-2 px-4 border-b border-gray-200">{msg.status}</td>
//                 <td className="py-2 px-4 border-b border-gray-200">
//                   {new Date(msg.scheduledDate).toLocaleString()}
//                 </td>
//                 <td className="py-2 px-4 border-b border-gray-200">
//                   <Link
//                     to={`/admin/textMessages/${msg._id}/edit`}
//                     className="bg-blue-500 text-white py-1 px-3 rounded hover:bg-blue-700 transition duration-200 mr-2"
//                   >
//                     <FaEdit />
//                   </Link>
//                   <button
//                     onClick={() => {
//                       setSelectedMessageId(msg._id);
//                       setIsDialogOpen(true);
//                     }}
//                     className="bg-red-500 text-white py-1 px-3 rounded hover:bg-red-700 transition duration-200"
//                   >
//                     <FaTrash />
//                   </button>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>

//       <ConfirmDialog
//         isOpen={isDialogOpen}
//         title="Delete Text Message"
//         message="Are you sure you want to delete this text message? This action cannot be undone."
//         onConfirm={handleDelete}
//         onCancel={() => setIsDialogOpen(false)}
//       />
//     </div>
//   );
// };

// export default AdminTextMessages;

// import React, { useEffect, useState } from 'react';
// import axios from 'axios';
// import { FaRegEdit, FaTrashAlt, FaPlus } from 'react-icons/fa';

// const AdminTextMessages = () => {
//   const [textMessages, setTextMessages] = useState([]);
//   const [loading, setLoading] = useState(true);

//   const token = localStorage.getItem('adminToken');

//   useEffect(() => {
//     const fetchTextMessages = async () => {
//       try {
//         const response = await axios.get('/api/admin/textmessages', {
//           headers: { Authorization: `Bearer ${token}` },
//         });
//         setTextMessages(response.data);
//         setLoading(false);
//       } catch (error) {
//         console.error('Error fetching text messages:', error);
//         setLoading(false);
//       }
//     };

//     fetchTextMessages();
//   }, [token]);

//   const handleDelete = async (textMessageId) => {
//     try {
//       await axios.delete(`/api/admin/textmessages/${textMessageId}`, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setTextMessages(
//         textMessages.filter((message) => message._id !== textMessageId)
//       );
//     } catch (error) {
//       console.error('Error deleting text message:', error);
//     }
//   };

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className='container mx-auto px-4 py-8'>
//       <h1 className='text-3xl font-bold mb-6'>Manage Text Messages</h1>

//       <div className='mb-4'>
//         <button className='bg-green-500 hover:bg-green-600 text-white font-semibold py-2 px-4 rounded flex items-center'>
//           <FaPlus className='mr-2' /> Add New Text Message
//         </button>
//       </div>

//       <ul>
//         {textMessages.map((message) => (
//           <li
//             key={message._id}
//             className='mb-4 p-4 bg-gray-100 rounded shadow-sm flex justify-between items-center'
//           >
//             <div>
//               <h2 className='text-xl font-semibold'>{message.content}</h2>
//               <p>Status: {message.status}</p>
//               <p>
//                 Scheduled Date:{' '}
//                 {new Date(message.scheduledDate).toLocaleString()}
//               </p>
//             </div>
//             <div className='flex items-center'>
//               <button className='bg-blue-500 hover:bg-blue-600 text-white font-semibold py-2 px-4 rounded mr-2 flex items-center'>
//                 <FaRegEdit className='mr-2' /> Edit
//               </button>
//               <button
//                 onClick={() => handleDelete(message._id)}
//                 className='bg-red-500 hover:bg-red-600 text-white font-semibold py-2 px-4 rounded flex items-center'
//               >
//                 <FaTrashAlt className='mr-2' /> Delete
//               </button>
//             </div>
//           </li>
//         ))}
//       </ul>
//     </div>
//   );
// };

// export default AdminTextMessages;
